export enum ObjectType {
  Arena = 1,
  User = 2,
  Contact = 3,
  Offering = 4,
  Prospect = 5,
  Account = 6,
  Property = 7,
  CommPref = 8,
  Position = 9,
  Document = 10,
  EmailBatch = 11,
  CapitalCallBatch = 12,
  DistributionBatch = 13,
  Transaction = 14,
  Asset = 15,
  ProspectContactMap = 16,
  DataRoom = 17,
  NetIncomeBatch = 18,
  Publication = 20,
  SubscriptionBatch = 21,
  Subscription = 22,
  EventLog = 23,
  PaymentBatch = 24,
  ManagementFeeBatch = 25,
  Task = 26,
  Lead = 27,
  CRMNotificationList = 28,
  NavBatch = 29,
  Loan = 30,
  AssetDateSampledData = 31,
  TransactionBatch = 32,
  UnitValue = 33,
  UnitValueBatch = 34,
  CapitalCall = 35,
  Distribution = 36,
  NetIncome = 37,
  Nav = 38,
  Note = 39,
  StoredEmail = 40,
  Email = 41,
  InvestorDiligence = 42,
  WatchingScreeningDetail = 43,
  KycDetail = 44,
  KycDocument = 45,
  KycDocumentVersion = 46,
  ImportTemplate = 47,
  KycDocumentVersionActivity = 48,
  Acquisition = 49,
  Disposition = 50,
  FeatureFlag = 51,
  PaymentPref = 52,
  ESignatureRequestTemplate = 56,
  EntityCollection = 73,
  ComplianceProfile = 74,
  ExtensionField = 75,
}
